import AbstractAnalyticProvider from 'coreClasses/analytics/providers/AbstractAnalyticProvider';
import {IAnalyticsProvidersConfiguration} from 'coreClasses/analytics/IAnalytics';

import AnalyticsProvidersFactory from './AnalyticsProvidersFactory';
import ManagerRepository from 'brandClasses/ManagerRepository';

/**
 * Represents AnalyticsProvidersMgr
 */
class AnalyticsProvidersMgr {
	/**
	 * Returns Analytics provider by name
	 * @param {string} providerName - name of analytics provider
	 * @returns {AbstractAnalyticProvider | null} - analytics provider
	 */
	public static getAnalyticsProvider(
		providerName?: string,
		managerRepository?: ManagerRepository,
		providersConfiguration?: IAnalyticsProvidersConfiguration
	): AbstractAnalyticProvider | null {
		return AnalyticsProvidersFactory.create(providerName, managerRepository, providersConfiguration);
	}
}

export default AnalyticsProvidersMgr;
